import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import React from 'react';

const TwitterIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <path d="M17.7724 4H20.6495L14.3654 11.201L21.7586 21H15.9704L11.4367 15.0559L6.24876 21H3.37048L10.0919 13.2972L3 4H8.93593L13.0335 9.43179L17.7724 4ZM16.7641 19.2742H18.3586L8.06834 5.63552H6.35897L16.7641 19.2742Z" />
    </SvgIcon>
  );
};

export default TwitterIcon;
